import { render, staticRenderFns } from "./company-info.vue?vue&type=template&id=74bceeb4&scoped=true&"
import script from "./company-info.ts?vue&type=script&lang=ts&"
export * from "./company-info.ts?vue&type=script&lang=ts&"
import style0 from "./company-info.vue?vue&type=style&index=0&id=74bceeb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bceeb4",
  null
  
)

export default component.exports